import { FeaturePanel } from '@engine/features/feature_panel';
import WpfPanels from '@engine/features/merchant/merchant_wpf_panels';
var changed_inputs = [];
var container = '.wpf-supported-features-wrapper';
var Panel = new FeaturePanel(container, {
  errorMessageTemplate: function errorMessageTemplate(message, errors) {
    return message + '</br>' + errors[0] + ': ' + errors[1];
  }
});

function getSelectedFeatures() {
  var $selected_checkboxes = $(container).find('input[name="features[]"]:checked');
  return $.map($selected_checkboxes, function (element) {
    return $(element).val();
  });
}

function listenForUpdates() {
  var $supported_features_checkboxes = $(container + ' input');
  $supported_features_checkboxes.on('change', function (event) {
    Panel.update({
      features: getSelectedFeatures()
    }, function () {
      changed_inputs.push(event.target.value);
    }, function () {
      WpfPanels.updateDependentFeaturesPanels(changed_inputs);
      changed_inputs = [];
    });
  });
}

var WpfSupportedFeatures = {
  listenForUpdates: listenForUpdates
};
export default WpfSupportedFeatures;